import { render, staticRenderFns } from "./TenderProfile.vue?vue&type=template&id=232b10e4&scoped=true"
import script from "./TenderProfile.vue?vue&type=script&lang=js"
export * from "./TenderProfile.vue?vue&type=script&lang=js"
import style0 from "./TenderProfile.vue?vue&type=style&index=0&id=232b10e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b10e4",
  null
  
)

export default component.exports